// extracted by mini-css-extract-plugin
module.exports = {"button":"_5D28Vhtb","button__icon":"_5D9a78hN","button__text":"_5D2-EKcc"};